import { computed, toValue } from "vue";
import { f as RX_NUMBER } from "./constants-DameGf19.mjs";
const useNumberishToStyle = (el, unit = "px") => computed(() => {
  const value = toValue(el);
  const resolvedUnit = toValue(unit);
  return RX_NUMBER.test(String(value)) ? `${Number(value)}${resolvedUnit}` : value;
});
export {
  useNumberishToStyle as u
};
//# sourceMappingURL=useNumberishToStyle-DZ5YuCPf.mjs.map
